const VoucherProductApplyType = {
  ORDER: 1,
  VOUCHER: 2
}
export default VoucherProductApplyType
